var render = function render(){var _vm=this,_c=_vm._self._c;return _c('n-theme',{attrs:{"type":"driver"}},[_c(_vm.renderTrip,_vm._b({tag:"component",attrs:{"driver-trip":_vm.driverTrip}},'component',_vm.parentProps,false)),_c('cancel-driver-trip-dialog',{ref:"cancelDialog"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }